/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReorderDevicesDto } from '../../models/reorder-devices-dto';

export interface DeviceGroupControllerReorderDevices$Params {
  id: string;
  clientWorkspaceId: string;
      body: ReorderDevicesDto
}

export function deviceGroupControllerReorderDevices(http: HttpClient, rootUrl: string, params: DeviceGroupControllerReorderDevices$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deviceGroupControllerReorderDevices.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deviceGroupControllerReorderDevices.PATH = '/api/device-group/{clientWorkspaceId}/{id}/reorder';
